import { z } from 'zod'
const jsonObject = z.record(z.unknown())
export const billingContractSignalBindingResponseSchema = jsonObject
export type BillingContractSignalBindingResponse = z.infer<typeof billingContractSignalBindingResponseSchema>
